import type { CommandRegistry } from "@pix/script";

/**
 * core-audio プラグイン: @bgm, @se, @voice
 *
 * Phase 1 MVP: 実際の再生はスタブ(console ログのみ)。
 * Phase 2 以降で Web Audio API + manifest からの解決を実装。
 */
export function registerCoreAudio(registry: CommandRegistry): void {
  registry.register({
    name: "bgm",
    async execute(args, sub, ctx) {
      if (sub === "play") {
        const file = String(args["file"] ?? args["play"] ?? "");
        await ctx.audio.playBgm(file, args);
      } else if (sub === "stop") {
        await ctx.audio.stopBgm(args);
      } else if (sub === "volume") {
        await ctx.audio.playBgm("__volume__", args);
      }
    },
  });

  registry.register({
    name: "se",
    async execute(args, sub, ctx) {
      const slot = Number(args["slot"] ?? 0);
      if (sub === "play") {
        const file = String(args["file"] ?? "");
        await ctx.audio.playSe(slot, file, args);
      } else if (sub === "stop") {
        await ctx.audio.stopSe(slot, args);
      }
    },
  });

  registry.register({
    name: "voice",
    async execute(args, sub, ctx) {
      const channel = Number(args["ch"] ?? args["channel"] ?? 0);
      if (sub === "play") {
        const file = String(args["file"] ?? "");
        await ctx.audio.playVoice(channel, file, args);
      } else if (sub === "stop") {
        await ctx.audio.stopVoice(channel);
      }
    },
  });
}
